import { Box, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { workflowsConditionsIcons } from "../../../stack/environment/icons/iconExport";

const AddMenuButton = ({
  selectedCondition,
  selectedConditions = [],
  showConditionSelector,
  selectedActions = [],
  selectedTrigger,
  getAvailableActions,
  onAddCondition,
  onAddAction,
  onAddActionIfMet,
  onAddActionIfNotMet,
}) => {
  const colors = useColors();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddCondition = () => {
    onAddCondition();
    handleClose();
  };

  const handleAddAction = () => {
    onAddAction();
    handleClose();
  };

  const handleAddActionIfMet = () => {
    onAddActionIfMet();
    handleClose();
  };

  const handleAddActionIfNotMet = () => {
    onAddActionIfNotMet();
    handleClose();
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "8px",
          marginBottom: "8px",
        }}
      >
        <Box
          onClick={handleClick}
          sx={{
            width: "28px",
            height: "28px",
            border: `1px solid ${colors.grey_20percent}`,
            backgroundColor: colors.common_white,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: colors.grey_5percent,
              borderColor: colors.primary_main,
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              color: colors.primary_main,
            }}
          >
            +
          </Typography>
        </Box>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          "& .MuiMenu-list": {
            padding: "4px 0",
          },
        }}
        PaperProps={{
          style: {
            borderRadius: "8px",
            padding: "4px 8px",
            minWidth: "160px",
            boxShadow: "0px 2px 8px 0px " + colors.grey_48percent,
          },
        }}
      >
        {!selectedCondition &&
          selectedConditions.length === 0 &&
          !showConditionSelector && (
            <MenuItem
              onClick={handleAddCondition}
              sx={{
                padding: "8px 12px",
                "&:hover": {
                  backgroundColor: colors.grey_4percent,
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  width: "100%",
                }}
              >
                <SvgToIcon
                  IconLogo={workflowsConditionsIcons.If}
                  style={{
                    width: "16px",
                    height: "16px",
                    color: colors.text_secondary,
                  }}
                />
                <Typography variant="body2">Add condition</Typography>
              </Box>
            </MenuItem>
          )}
        {getAvailableActions(selectedCondition || selectedTrigger).length >
          selectedActions.length && (
          <>
            {/* Show conditional action options when there are conditions */}
            {selectedCondition || selectedConditions.length > 0 ? (
              <>
                <MenuItem
                  onClick={handleAddActionIfMet}
                  sx={{
                    padding: "8px 12px",
                    "&:hover": {
                      backgroundColor: colors.grey_4percent,
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      width: "100%",
                    }}
                  >
                    <SvgToIcon
                      IconLogo={workflowsConditionsIcons.Then}
                      style={{
                        width: "16px",
                        height: "16px",
                        color: colors.text_secondary,
                      }}
                    />
                    <Typography variant="body2">
                      If conditions are met
                    </Typography>
                  </Box>
                </MenuItem>
                <MenuItem
                  onClick={handleAddActionIfNotMet}
                  sx={{
                    padding: "8px 12px",
                    "&:hover": {
                      backgroundColor: colors.grey_4percent,
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      width: "100%",
                    }}
                  >
                    <SvgToIcon
                      IconLogo={workflowsConditionsIcons.Then}
                      style={{
                        width: "16px",
                        height: "16px",
                        color: colors.text_secondary,
                      }}
                    />
                    <Typography variant="body2">
                      If conditions are not met
                    </Typography>
                  </Box>
                </MenuItem>
              </>
            ) : (
              /* Show simple "Add action" when there are no conditions */
              <MenuItem
                onClick={handleAddAction}
                sx={{
                  padding: "8px 12px",
                  "&:hover": {
                    backgroundColor: colors.grey_4percent,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    width: "100%",
                  }}
                >
                  <SvgToIcon
                    IconLogo={workflowsConditionsIcons.Then}
                    style={{
                      width: "16px",
                      height: "16px",
                      color: colors.text_secondary,
                    }}
                  />
                  <Typography variant="body2">Add action</Typography>
                </Box>
              </MenuItem>
            )}
          </>
        )}
      </Menu>
    </>
  );
};

export default AddMenuButton;
